import React from 'react';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import CustomerSearchList from './CustomerSearchList';
import DashboardHeader from './DashboardHeader';
import JobSearchList from './JobSearchList';
import QuickSearch from './QuickSearch';
import Row from 'react-bootstrap/Row';

const DashboardView = () => {
    const navigateUrl = (url) => window.location.assign(url);

    return (
        <BrowserRouter>
            <Row>
                <Col className="dashboard">
                    <Row className="justify-content-center">
                        <DashboardHeader
                            navigateUrl={navigateUrl}
                        />
                    </Row>
                    <Row>
                        <Col>
                            <Routes>
                                <Route path='/dashboard'
                                       element={<QuickSearch navigateUrl={navigateUrl} />}
                                />
                                <Route path='/dashboard/customers'
                                    element={<CustomerSearchList navigateUrl={navigateUrl} />}
                                />
                                <Route path='/dashboard/jobs'
                                    element={<JobSearchList navigateUrl={navigateUrl} />}
                                />
                                <Route path="" element={<Navigate to="/dashboard" />} />
                            </Routes>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </BrowserRouter>
    );
}

export default DashboardView;